(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artToWear-collection"] && !Shopify.designMode) return;
  try {
    

  function setVisible(tile, show) {
    if (show) {
      tile.classList.remove("is-gone");
      requestAnimationFrame(() => tile.classList.remove("is-hidden"));
    } else {
      tile.classList.add("is-hidden");
      tile.addEventListener("transitionend", function onEnd(e) {
        if (e.propertyName === "opacity" && tile.classList.contains("is-hidden")) {
          tile.classList.add("is-gone");
        }
        tile.removeEventListener("transitionend", onEnd);
      });
    }
  }

  function filterTilesByArtist(artist_filters) {
    const set = new Set((artist_filters || []).map(a => String(a).trim()));
    document.querySelectorAll(".variant-tile").forEach(tile => {
      const artist = (tile.dataset.artist || "").trim();
      setVisible(tile, set.size === 0 || set.has(artist));
    });
  }



  function initArtistBadgesScrollHints() {
    const wrappers = document.querySelectorAll(".artist-badges-wrapper");

    wrappers.forEach(wrapper => {
      if (wrapper.dataset.scrollHintInitialized === "true") return;
      wrapper.dataset.scrollHintInitialized = "true";
      const scroller = wrapper.querySelector("#artist-badges");
      if (!scroller) return;
      const leftHint = wrapper.querySelector(".artist-scroll-hint--left");
      const rightHint = wrapper.querySelector(".artist-scroll-hint--right");
      const scrollbar = wrapper.querySelector(".artist-scrollbar");
      const thumb = scrollbar.querySelector(".artist-scrollbar-thumb");

      const updateHint = () => {
        const maxScrollLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        const canScroll = getComputedStyle(scroller).overflowX === "auto" && maxScrollLeft > 2;
        if (leftHint) leftHint.hidden = !canScroll || scroller.scrollLeft <= 2;
        if (rightHint) rightHint.hidden = !canScroll || scroller.scrollLeft >= maxScrollLeft - 2;
        scrollbar.hidden = !canScroll;
        if (canScroll) {
          const trackWidth = scrollbar.clientWidth;
          const thumbWidth = Math.min(trackWidth, Math.max(32, trackWidth * scroller.clientWidth / scroller.scrollWidth));
          thumb.style.width = `${thumbWidth}px`;
          thumb.style.transform = `translateX(${(scroller.scrollLeft / maxScrollLeft) * (trackWidth - thumbWidth)}px)`;
          scrollbar.setAttribute("aria-valuemax", String(Math.round(maxScrollLeft)));
          scrollbar.setAttribute("aria-valuenow", String(Math.round(scroller.scrollLeft)));
        }
      };

      if (leftHint) leftHint.addEventListener("click", () => scroller.scrollBy({ left: -scroller.clientWidth * 0.7, behavior: "smooth" }));
      if (rightHint) rightHint.addEventListener("click", () => scroller.scrollBy({ left: scroller.clientWidth * 0.7, behavior: "smooth" }));

      const scrollToPointer = event => {
        const rect = scrollbar.getBoundingClientRect();
        const thumbWidth = thumb.getBoundingClientRect().width;
        const travel = rect.width - thumbWidth;
        const position = Math.max(0, Math.min(travel, event.clientX - rect.left - thumbWidth / 2));
        scroller.scrollLeft = travel > 0 ? position / travel * (scroller.scrollWidth - scroller.clientWidth) : 0;
      };
      scrollbar.addEventListener("pointerdown", event => {
        scrollbar.setPointerCapture(event.pointerId);
        scrollToPointer(event);
      });
      scrollbar.addEventListener("pointermove", event => {
        if (scrollbar.hasPointerCapture(event.pointerId)) scrollToPointer(event);
      });
      scrollbar.addEventListener("keydown", event => {
        const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
        if (event.key === "ArrowLeft") scroller.scrollLeft -= 40;
        else if (event.key === "ArrowRight") scroller.scrollLeft += 40;
        else if (event.key === "Home") scroller.scrollLeft = 0;
        else if (event.key === "End") scroller.scrollLeft = maxScrollLeft;
        else return;
        event.preventDefault();
      });
      updateHint();
      scroller.addEventListener("scroll", updateHint, { passive: true });
      window.addEventListener("resize", updateHint);
      setTimeout(updateHint, 250);
    });
  }

  function initArtistBadges() {
    initArtistBadgesScrollHints();

    var badges = document.querySelectorAll(".artist-badge");

    badges.forEach(badge => {
      if (badge.dataset.artistFilterInitialized === "true") return;
      badge.dataset.artistFilterInitialized = "true";
      badge.addEventListener("click", function() {
        badge.classList.toggle("active");
        const active_badges = document.querySelectorAll(".artist-badge.active");
        const artist_filters = [...new Set(
          [...active_badges].map(el => el.dataset.artist).filter(Boolean)
        )];
        filterTilesByArtist(artist_filters);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initArtistBadges);
  } else {
    initArtistBadges();
  }
  document.addEventListener("shopify:section:load", initArtistBadges);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-rich-text-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('custom-rich-text-tabs')) {
  customElements.define('custom-rich-text-tabs', class extends HTMLElement {
    connectedCallback() {
      // The deferred section script runs after markup parsing; reconnects remain safe.
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.tabs = Array.from(this.querySelectorAll('.ct-tab'));
      this.panels = Array.from(this.querySelectorAll('.ct-panel'));
      if (!this.tabs.length) return;
      this.menu = this.querySelector('.ct-menu');
      this.menu.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panels[index].id);
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        this.panels[index].tabIndex = 0;
        tab.addEventListener('click', event => { event.preventDefault(); this.activate(index, false, true); }, options);
        tab.addEventListener('keydown', event => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          let next;
          if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (event.key === ' ') next = index;
          if (next === undefined) return;
          event.preventDefault();
          this.activate((next + this.tabs.length) % this.tabs.length, true, true);
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.tabs.findIndex(tab => tab.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.activate(index, false, true);
      }, options);
      this.scrollbar = this.querySelector('.ct-scrollbar');
      this.scrollbarThumb = this.querySelector('.ct-scrollbar-thumb');
      if (this.querySelector('.ct-scroll-hint') || this.scrollbar) {
        this.menu.addEventListener('scroll', () => this.updateScrollHints(), options);
        window.addEventListener('resize', () => this.updateScrollHints(), options);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateScrollHints());
          this.resizeObserver.observe(this.menu);
        }
        document.fonts?.ready.then(() => this.updateScrollHints());
      }
      this.activate(0);
      requestAnimationFrame(() => this.updateScrollHints());
    }
    activate(index, focus = false, reveal = false) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
      const tab = this.tabs[index];
      if (focus) tab.focus({ preventScroll: true });
      if (reveal) {
        // Move only the horizontal menu, avoiding page jumps on selection.
        const menu = tab.parentElement;
        const box = tab.getBoundingClientRect();
        const bounds = menu.getBoundingClientRect();
        if (menu.scrollWidth > menu.clientWidth) {
          if (box.left < bounds.left) menu.scrollLeft += box.left - bounds.left - 4;
          else if (box.right > bounds.right) menu.scrollLeft += box.right - bounds.right + 4;
        }
      }
      requestAnimationFrame(() => this.updateScrollHints());
    }
    updateScrollHints() {
      if (!this.menu) return;
      const bounds = this.menu.getBoundingClientRect();
      const tabBounds = this.tabs.map(tab => tab.getBoundingClientRect());
      const leftEdge = Math.min(...tabBounds.map(box => box.left));
      const rightEdge = Math.max(...tabBounds.map(box => box.right));
      const overflow = this.menu.scrollWidth > this.menu.clientWidth + 1;
      this.classList.toggle('has-scroll-overflow', overflow);
      this.classList.toggle('show-left-hint', overflow && leftEdge < bounds.left - 1);
      this.classList.toggle('show-right-hint', overflow && rightEdge > bounds.right + 1);
      if (overflow && this.scrollbar && this.scrollbarThumb) {
        const trackWidth = this.scrollbar.clientWidth;
        const thumbWidth = Math.min(trackWidth, Math.max(24, trackWidth * this.menu.clientWidth / this.menu.scrollWidth));
        const hiddenLeft = Math.max(0, bounds.left - leftEdge);
        const hiddenRight = Math.max(0, rightEdge - bounds.right);
        const progress = hiddenLeft + hiddenRight > 0 ? hiddenLeft / (hiddenLeft + hiddenRight) : 0;
        this.scrollbarThumb.style.width = `${thumbWidth}px`;
        this.scrollbarThumb.style.transform = `translateX(${(trackWidth - thumbWidth) * progress}px)`;
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horizontal-product-tiles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('horizontal-product-tiles')) {
    customElements.define('horizontal-product-tiles', class extends HTMLElement {
      connectedCallback() {
        // Defer until this element's children have been parsed.
        this.initFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        this.track = this.querySelector('.hpt__track');
        if (!this.track) return;
        this.chevrons = [...this.querySelectorAll('.hpt__chevron')];
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.addEventListener('click', async event => {
          const button = event.target.closest('[data-copy-variant]');
          if (!button) return;
          const help = button.closest('.hpt__editor-help');
          const field = button.parentElement.querySelector('input');
          const status = help.querySelector('.hpt__copy-status');
          field.focus();
          field.select();
          try {
            await navigator.clipboard.writeText(button.dataset.copyVariant);
            status.textContent = 'Copied. Paste into the Variant ID setting in the sidebar.';
          } catch {
            status.textContent = 'ID selected. Copy it manually, then paste into the Variant ID setting.';
          }
        }, { signal });

        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.schedule, { passive: true, signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal });
        this.addEventListener('load', this.schedule, { capture: true, signal });
        this.chevrons.forEach(chevron => {
          chevron.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            const first = this.tiles()[0];
            if (!first) return;
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
            this.track.scrollBy({
              left: Number(chevron.dataset.step) * direction * (first.getBoundingClientRect().width + gap),
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }, { signal });
        });
        this.addEventListener('shopify:block:select', event => {
          const tile = this.tiles().find(item => item === event.target || item.contains(event.target));
          if (!tile) return;
          const rect = tile.getBoundingClientRect();
          const viewport = this.track.getBoundingClientRect();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          // Scroll only this track, never the whole editor page.
          this.track.scrollBy({ left: rtl ? rect.right - viewport.right : rect.left - viewport.left, behavior: 'instant' });
        }, { signal });
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.observeSizes = () => {
          this.resizeObserver.disconnect();
          this.resizeObserver.observe(this.track);
          this.tiles().forEach(tile => this.resizeObserver.observe(tile));
          this.track.querySelectorAll('img, svg').forEach(image => this.resizeObserver.observe(image));
          this.schedule();
        };
        this.mutationObserver = new MutationObserver(this.observeSizes);
        this.mutationObserver.observe(this.track, { childList: true, subtree: true });
        this.observeSizes();
      }
      tiles() {
        return [...this.track.children].filter(item => item.classList.contains('hpt__tile'));
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const overflow = max > 2;
        // Modern browsers use negative scrollLeft for RTL; clamp elastic overscroll.
        const position = Math.min(max, Math.max(0, Math.abs(this.track.scrollLeft)));
        if (!this.chevrons.length) return;
        const viewport = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const images = [...this.track.querySelectorAll('.hpt__media')]
          .map(image => image.getBoundingClientRect())
          .filter(rect => rect.width > 0 && rect.height > 0 && rect.right > viewport.left && rect.left < viewport.right);
        const inner = this.querySelector('.hpt__inner').getBoundingClientRect();
        this.chevrons.forEach(chevron => {
          const step = Number(chevron.dataset.step);
          const atEdge = step < 0 ? position <= 2 : position >= max - 2;
          const onStartSide = step < 0;
          const hintX = onStartSide
            ? (rtl ? viewport.right - 30 : viewport.left + 30)
            : (rtl ? viewport.left + 30 : viewport.right - 30);
          // Prefer the image under this chevron, excluding captions from centering.
          const image = images.find(rect => rect.left <= hintX && rect.right >= hintX)
            || (onStartSide === rtl ? images[images.length - 1] : images[0]);
          chevron.hidden = !overflow || atEdge || !image;
          if (image) {
            chevron.style.setProperty('--hpt-hint-top', `${image.top + image.height / 2 - inner.top}px`);
          }
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.frame);
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horizontal-tiles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('horizontal-tiles')) {
    customElements.define('horizontal-tiles', class extends HTMLElement {
      connectedCallback() {
        // Defer until this element's children have been parsed.
        this.initFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        this.track = this.querySelector('.ht__track');
        if (!this.track) return;
        this.chevrons = [...this.querySelectorAll('.ht__chevron')];
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.schedule, { passive: true, signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal });
        this.addEventListener('load', this.schedule, { capture: true, signal });
        this.chevrons.forEach(chevron => {
          chevron.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            const first = this.tiles()[0];
            if (!first) return;
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
            this.track.scrollBy({
              left: Number(chevron.dataset.step) * direction * (first.getBoundingClientRect().width + gap),
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }, { signal });
        });
        this.addEventListener('shopify:block:select', event => {
          const tile = this.tiles().find(item => item === event.target || item.contains(event.target));
          if (!tile) return;
          const rect = tile.getBoundingClientRect();
          const viewport = this.track.getBoundingClientRect();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          // Scroll only this track, never the whole editor page.
          this.track.scrollBy({ left: rtl ? rect.right - viewport.right : rect.left - viewport.left, behavior: 'instant' });
        }, { signal });
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.observeSizes = () => {
          this.resizeObserver.disconnect();
          this.resizeObserver.observe(this.track);
          this.tiles().forEach(tile => this.resizeObserver.observe(tile));
          this.track.querySelectorAll('img, svg').forEach(image => this.resizeObserver.observe(image));
          this.schedule();
        };
        this.mutationObserver = new MutationObserver(this.observeSizes);
        this.mutationObserver.observe(this.track, { childList: true, subtree: true });
        this.observeSizes();
      }
      tiles() {
        return [...this.track.children]
          .filter(item => !['SCRIPT', 'STYLE', 'TEMPLATE'].includes(item.tagName))
          .map(item => {
            if (item.getClientRects().length) return item;
            // Shopify can wrap theme blocks in a display: contents element.
            // Resolve that zero-size wrapper to the box that participates in the grid.
            return [...item.querySelectorAll('*')].find(node => node.getClientRects().length);
          })
          .filter(Boolean);
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const overflow = max > 2;
        // Modern browsers use negative scrollLeft for RTL; clamp elastic overscroll.
        const position = Math.min(max, Math.max(0, Math.abs(this.track.scrollLeft)));
        if (!this.chevrons.length) return;
        const viewport = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const images = [...this.track.querySelectorAll('img, .placeholder-svg, svg')]
          .map(image => image.getBoundingClientRect())
          .filter(rect => rect.width > 0 && rect.height > 0 && rect.right > viewport.left && rect.left < viewport.right);
        const inner = this.querySelector('.ht__inner').getBoundingClientRect();
        this.chevrons.forEach(chevron => {
          const step = Number(chevron.dataset.step);
          const atEdge = step < 0 ? position <= 2 : position >= max - 2;
          const onStartSide = step < 0;
          const hintX = onStartSide
            ? (rtl ? viewport.right - 30 : viewport.left + 30)
            : (rtl ? viewport.left + 30 : viewport.right - 30);
          // Prefer the image under this chevron, excluding captions from centering.
          const image = images.find(rect => rect.left <= hintX && rect.right >= hintX)
            || (onStartSide === rtl ? images[images.length - 1] : images[0]);
          chevron.hidden = !overflow || atEdge || !image;
          if (image) {
            chevron.style.setProperty('--ht-hint-top', `${image.top + image.height / 2 - inner.top}px`);
          }
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.frame);
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pre-footer-accordion')) {
    class PreFooterAccordion extends HTMLElement {
      connectedCallback() {
        // Shopify can reconnect or replace a section while editing.
        if (this.controller) return;
        this.details = this.querySelector('.pf-details');
        if (!this.details) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.media = window.matchMedia(`(max-width: ${Number(this.dataset.breakpoint) || 749}px)`);
        this.states = {
          desktop: this.dataset.desktopOpen === 'true',
          mobile: this.dataset.mobileOpen === 'true'
        };
        this.editorReveal = false;
        this.mode = this.media.matches ? 'mobile' : 'desktop';
        this.applyState();
        this.setAttribute('data-enhanced', '');

        this.details.addEventListener('toggle', () => {
          if (!this.editorReveal) this.states[this.mode] = this.details.open;
        }, options);
        this.media.addEventListener('change', () => {
          // Remember a native toggle even if its asynchronous event is pending.
          if (!this.editorReveal) this.states[this.mode] = this.details.open;
          this.mode = this.media.matches ? 'mobile' : 'desktop';
          this.applyState();
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const selected = Array.from(this.querySelectorAll('[data-shop-block-id]'))
            .some((block) => block.dataset.shopBlockId === event.detail.blockId);
          if (!selected) return;
          if (!this.editorReveal) this.states[this.mode] = this.details.open;
          this.editorReveal = true;
          this.applyState();
        }, options);
        document.addEventListener('shopify:block:deselect', (event) => {
          const selected = Array.from(this.querySelectorAll('[data-shop-block-id]'))
            .some((block) => block.dataset.shopBlockId === event.detail.blockId);
          if (!selected) return;
          this.editorReveal = false;
          this.applyState();
        }, options);
      }

      applyState() {
        const open = this.editorReveal || this.states[this.mode];
        // Avoid leaving keyboard focus inside a panel that is about to close.
        if (!open && this.querySelector('.pf-panel').contains(document.activeElement)) {
          this.querySelector('.pf-summary').focus();
        }
        this.details.open = open;
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
        this.removeAttribute('data-enhanced');
      }
    }
    customElements.define('pre-footer-accordion', PreFooterAccordion);
  }

  } catch(e) { console.error(e); }
})();
})();
